import React from "react";
import styled from "styled-components";
import axios from "axios";

const OrderAsset = () => {
    return <p>Asset ordering is currently only available via the planner.</p>;
};

export default OrderAsset;
